const payment = {
  proceedPayment: "Proceed to payment",
  retryPayment: "Proceed to payment again",
  paymentErrorTitle: "Payment failed",
  paymentErrorContent:
    "Make sure you have entered the correct information. If the error persists, please contact the administrator.",
  paymentSuccessTitle: "Payment successful",
  paymentSuccessContent:
    "Your payment has been confirmed. Your subscription is now active.",
};

export default payment;
